import { dispatchUserInteractionEvent } from './dispatchUserInteractionEvent';
import { urls } from '@zapier/identity-utils';

export function dispatchContinueWithSSOButtonClickedEvent() {
  const currentAbsoluteUrl = window.location.toString();
  const loginWithSSOURL = new URL(currentAbsoluteUrl);
  loginWithSSOURL.pathname = urls.LOGIN_WITH_SSO_URL;

  return dispatchUserInteractionEvent({
    destination_url_address: loginWithSSOURL.toString(),
    event_action: 'click',
    option_selected: loginWithSSOURL.toString(),
    interaction_name: 'continue_with_sso_social_button',
    interaction_raw_text: 'Continue with SSO',
    interaction_goal: 'Start SAML authentication flow',
  });
}

export function dispatchSAMLSSOFormFocussedEvent() {
  return dispatchUserInteractionEvent({
    event_action: 'click',
    option_selected: 'SAML_SSO_form_focus',
    interaction_name: 'SAML_SSO_form_focus',
    interaction_goal: 'Start entering email address',
  });
}

export function dispatchSAMLSSOFormSubmittedEvent() {
  return dispatchUserInteractionEvent({
    event_action: 'click',
    option_selected: 'SAML_SSO_form_submitted',
    interaction_name: 'SAML_SSO_form_submitted',
    interaction_raw_text: 'Continue with SSO',
    interaction_goal: 'Submit email to redirect to SAML provider',
  });
}
